import {
  type CasinoLastWinner,
  Messages,
  TransportManager,
} from '@atlas/transport';
import { useEffect, useRef, useState } from 'react';

import { lastWinnersRequest } from 'api/casino';

const MAX_ITEMS_COUNT = 10;

const useLastWinners = (projectId: string, delay: number) => {
  const [items, setItems] = useState<CasinoLastWinner[]>([]);
  const queue = useRef<CasinoLastWinner[]>([]);
  const transport = TransportManager.getInstance();
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>();

  const moveItemFromQueue = useRef(() => {
    if (timer.current) {
      return;
    }

    const item = queue.current.shift();

    if (item) {
      setItems((prevState) => {
        const existing = prevState.find(
          ({ info }) => info.transactionId === item.info.transactionId,
        );
        if (existing) {
          moveItemFromQueue.current();
          return prevState;
        }
        timer.current = setTimeout(() => {
          timer.current = undefined;
          moveItemFromQueue.current();
        }, delay);
        return [item, ...prevState].slice(0, MAX_ITEMS_COUNT);
      });
    }
  });

  useEffect(() => {
    lastWinnersRequest().then((data) => {
      setItems(data);
    });

    return transport.subscribe(
      Messages.casinoLastWins(projectId),
      ({ payload }) => {
        const data = payload.data as CasinoLastWinner;
        queue.current.push(data);
        moveItemFromQueue.current();
      },
    );
  }, [projectId, transport]);

  return items;
};

export default useLastWinners;
